// Formatação pt-BR (Manual 02 — Escrita e formatos).
const numberFmt = new Intl.NumberFormat("pt-BR");
const currencyFmt = new Intl.NumberFormat("pt-BR", {
  style: "currency",
  currency: "BRL",
});
const compactFmt = new Intl.NumberFormat("pt-BR", {
  notation: "compact",
  maximumFractionDigits: 1,
});

export const EMPTY_VALUE = "—";

// A API devolve valores monetários como texto ("R$1.234,56"); este helper
// aceita texto ou número e devolve o número.
export const parseNumber = (value: string | number | null | undefined): number => {
  if (value == null) return 0;
  if (typeof value === "number") return Number.isFinite(value) ? value : 0;
  const cleaned = value
    .replace(/[^\d,.-]/g, "")
    .replace(/\.(?=\d{3}(\D|$))/g, "")
    .replace(",", ".");
  const parsed = Number.parseFloat(cleaned);
  return Number.isFinite(parsed) ? parsed : 0;
};

export const formatNumber = (value: number | null | undefined): string =>
  value == null ? EMPTY_VALUE : numberFmt.format(value);

export const formatCompact = (value: number): string => compactFmt.format(value);

export const formatCurrency = (
  value: string | number | null | undefined,
): string => (value == null || value === "" ? EMPTY_VALUE : currencyFmt.format(parseNumber(value)));

export const formatDecimal = (
  value: number | null | undefined,
  digits = 2,
): string =>
  value == null
    ? EMPTY_VALUE
    : value.toLocaleString("pt-BR", {
        minimumFractionDigits: digits,
        maximumFractionDigits: digits,
      });

export const formatPercent = (
  value: number | null | undefined,
  digits = 0,
): string =>
  value == null
    ? EMPTY_VALUE
    : `${value.toLocaleString("pt-BR", { maximumFractionDigits: digits })}%`;

export type ValueFormat = "number" | "currency" | "decimal" | "percent";

export const formatValue = (value: number | null | undefined, format: ValueFormat) => {
  switch (format) {
    case "currency":
      return formatCurrency(value);
    case "decimal":
      return formatDecimal(value);
    case "percent":
      return formatPercent(value, 2);
    default:
      return formatNumber(value);
  }
};

export const initials = (name?: string | null): string =>
  (name || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part[0]?.toUpperCase())
    .join("") || "?";

export const firstName = (name?: string | null): string =>
  (name || "").trim().split(/\s+/)[0] || "";
